import {ICustomer} from "./customer.model";
import {IOrganization} from "./organization.model";
import {IPhone} from "./phone.model";
import {IOrderObject} from "./order-object.model";
import {ITransaction} from "./transaction.model";
import {ICustomerFile} from "./customer-file.model";
import {IProject} from "./project.model";
import {IUser} from "../../core/user/user.model";
import {IEmployee} from "./employee.model";

export interface ISupplier {
    id?: number;
    itemName?: string;
    // status?: string;
    // code?: string;
    cost?: string;
    unit?: string;
    // title?: string;
    type?: string;
    // description?: string;
    // customer?: ICustomer;
  // organization?: IOrganization;




  customerId?: any;
  dashId?: number;
  address?: string;
  code?: string;
  behavior_type?: string;
  category?: string;
  deadline?: any;
  startDate?: any;
  city?: string;
  codeTarafHesab?: string;
  deleted?: string;
  description?: string;
  otherFeatures?: string;
  postalCode?: string;
  country?: string;
  state?: string;
  theMethodIntroduction?: string;
  title?: string;
  jalaliDate?: string;
  nationalId?: string;
  economicCode?: string;
  website?: string;
  isarchived?: boolean;
  isdeleted?: boolean;
  jhiType?: string;
  gender?: string;
  prefix?: string;
  email?: string;
  email2?: string;
  firstName?: string;
  lastName?: string;
  assign_list?: string;
  officeWork?: string;
  fieldActivity?: string;
  billing_points?: string;
  billingPoints?: string;
  level?: string;
  count_order?: string;
  max_date?: any;
  amount_order?: any;
  methodIntroduction?: string;
  connector?: string;
  status?: string;
  status_2?: string;
  phones?: IPhone[];
  orderObjects?: IOrderObject[];
  transactions?: ITransaction[];
  customerFiles?: ICustomerFile[];
  projects?: IProject[];
  users?: IUser[];
  employees?: IEmployee[];
  organization?: IOrganization;
  employees_set?: any[];
  employeeId?: any;
  employeeId_search?: any;
  lastModifiedBy?: any;
  createdDate?: any;
  lastModifiedDate?: any;
  last_modified_date?: any;
  created_date?: any;
  created_by?: any;
  createdBy?: any;

}

export class Supplier implements ISupplier {
    constructor(public id?: number, public itemName?: string, public status?: string,
                public type?: string,
                public title?: string,
                public unit?: string,
                public code?: string,
                public cost?: string,
                public jhiType?: string,
                public description?: string) {
      this.jhiType='حقوقی';
    }
}
